document.addEventListener("DOMContentLoaded", () => {
	const headers = document.querySelectorAll(".accordion-header");

	headers.forEach((header) => {
		header.addEventListener("click", () => {
			const button = header.querySelector(".accordion-button");
			const content = header.nextElementSibling;
			const isOpen = content.classList.contains("active");

			// Close all other open accordions
			document
				.querySelectorAll(".accordion-content.active")
				.forEach((openContent) => {
					const openButton =
						openContent.previousElementSibling.querySelector(
							".accordion-button"
						);

					// Set height to current pixel height for transition
					openContent.style.height = openContent.scrollHeight + "px";

					// Force reflow to apply height before collapsing
					openContent.offsetHeight;

					// Collapse to 0 height (triggers slide up)
					openContent.style.height = "0px";

					// Remove active classes after transition ends
					openContent.addEventListener(
						"transitionend",
						function closeTransition() {
							openContent.classList.remove("active");
							openButton.classList.remove("active");
							openContent.style.height = ""; // Clear inline height to allow auto-sizing later
							openContent.removeEventListener(
								"transitionend",
								closeTransition
							);
						}
					);
				});

			if (!isOpen) {
				// Open clicked accordion

				// Add active classes first (for styling)
				content.classList.add("active");
				button.classList.add("active");

				// Start from height 0 to trigger animation
				content.style.height = "0px";

				// Force reflow so the browser registers the height=0
				content.offsetHeight;

				// Animate height to scrollHeight (slide down)
				content.style.height = content.scrollHeight + "px";

				// After animation, reset height to auto for flexible height
				content.addEventListener(
					"transitionend",
					function openTransition() {
						if (content.classList.contains("active")) {
							content.style.height = "auto";
						}
						content.removeEventListener(
							"transitionend",
							openTransition
						);
					}
				);
			}
		});
	});
});
